import { render, staticRenderFns } from "./ChosenField.vue?vue&type=template&id=20063ebc&scoped=true&"
import script from "./ChosenField.vue?vue&type=script&lang=js&"
export * from "./ChosenField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20063ebc",
  null
  
)

export default component.exports